/** Parámetro canónico de las invitaciones Founder. */
export const FOUNDER_QUERY_PARAM = 'founder';

export function founderAccessCodeFrom(search: string): string {
  const params = new URLSearchParams(search);
  const canonical = params.get(FOUNDER_QUERY_PARAM)?.trim();
  if (canonical) return canonical;

  // Compatibilidad con el enlace inicial ya compartido. Solo se admite el
  // prefijo Founder para no confundir un callback OAuth real con la invitación.
  const legacy = params.get('code')?.trim() ?? '';
  return legacy.startsWith('FOUNDER-') ? legacy : '';
}
